module.exports = __webpack_public_path__ + "assets/img/084f9943dcb5f03993f2320e6c52c555.png";